import { createStore, combineReducers, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { authReducer } from './authentication/reducers/authReducer';
import { verifyAuth } from './authentication/actions';
import { userReducer } from './users/reducers/userReducer';
import { groupsReducer } from './groups/reducers/groupsReducer';
import { postReducer } from './posts/reducers';
import { appReducer } from './app/reducers';
import { leadersReducer } from './leaders/reducers';
import { libraryReducer } from './library/reducers';

const reducers = combineReducers({
  auth: authReducer,
  user: userReducer,
  groups: groupsReducer,
  posts: postReducer,
  app: appReducer,
  leaders: leadersReducer,
  library: libraryReducer,
});

export function configureStore() {
  const store = createStore(reducers, composeWithDevTools(applyMiddleware(thunk)));
  store.dispatch(verifyAuth());
  return store;
}

export {
  signIn,
  signOut,
  authLoaded,
  authLoading,
  newUser,
} from './authentication/actions/index';

export {
  loadUserDetails,
} from './users/actions/index';

export {
  approveGroupMemberAction,
  removeGroupMemberAction,
  deleteGroupAction,
  loadGroups,
  loadGroupMembers,
  updateGroupAction,
  updateListConfig,
  clearGroups,
} from './groups/actions/index';

export {
  createPostAction,
  getPostsAction,
  getPostDetailsAction,
  deletePostAction,
  deleteHighlightAction,
  updatePostListConfig,
  setSelectedPostDate,
  setPostGroup,
} from './posts/actions';

export {
  setAppLoadingState,
} from './app/actions';

export {
  getLeadersList,
  getLeaderGroupsList,
  setLeadersList,
  setLeaderSearchTerm,
  setFollowFilter,
  resetLeadersPage,
  followLeaderGroup,
  unFollowLeaderGroup,
  loadGroupPosts,
  userCanAccessPosts,
} from './leaders/actions';

export {
  getLibraryPostsAction,
  getMoreLibraryPostsActions,
} from './library/actions';

export type { IGroupListConfig } from './groups/reducers/groupsReducer';
